import { DspStats, StrategyDspFunnel } from "@front/m19-api-client";
import { Metric, MetricCategory, PALETTE, RatioMetric, SummableMetric, SupportedAccountType } from "@front/m19-metrics";
import { DspStrategyEx } from "@front/m19-models";
import { DspMetricsType, DspStrategyService } from "@front/m19-services";

export const DSP_SALES: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_SALES",
  field: "totalSales",
  title: "Sales",
  category: MetricCategory.DSP,
  color: PALETTE[1],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Sales",
});

export const DSP_UNITS_SOLD: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_UNITS_SOLD",
  field: "totalUnitsSold",
  title: "Units Sold",
  category: MetricCategory.DSP,
  color: PALETTE[2],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Units Sold",
});

export const DSP_COST: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_COST",
  field: "totalCost",
  title: "Cost",
  category: MetricCategory.DSP,
  color: PALETTE[0],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Cost",
  higherIsBetter: false,
});

export const DSP_IMPRESSIONS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_IMPRESSIONS",
  field: "impressions",
  title: "Impressions",
  category: MetricCategory.DSP,
  color: PALETTE[6],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Impressions",
});

export const DSP_CLICKS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_CLICKS",
  field: "clicks",
  title: "Clicks",
  category: MetricCategory.DSP,
  color: PALETTE[5],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Clicks",
});

export const DSP_FEE: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_FEE",
  field: "totalFee",
  title: "Fee",
  category: MetricCategory.DSP,
  color: PALETTE[4],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Fee",
});

export const DSP_PURCHASE_CLICKS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_PURCHASE_CLICKS",
  field: "totalPurchasesClicks",
  title: "Purchase Clicks",
  category: MetricCategory.DSP,
  color: PALETTE[7],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Purchase Clicks",
});

export const DSP_PURCHASES: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_PURCHASES",
  field: "totalPurchases",
  title: "Purchases",
  category: MetricCategory.DSP,
  color: PALETTE[8],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Purchases",
});

export const DSP_ADD_TO_CART: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_ADD_TO_CART",
  field: "totalAddToCart",
  title: "Add to Cart",
  category: MetricCategory.DSP,
  color: PALETTE[9],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Add to Cart",
});

export const DSP_PAGE_VIEWS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_PAGE_VIEWS",
  field: "totalDetailPageViewClicks",
  title: "Page Views",
  category: MetricCategory.DSP,
  color: PALETTE[19],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Page Views",
});

export const DSP_NEW_TO_BRAND_PRODUCT_SALES: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_NEW_TO_BRAND_PRODUCT_SALES",
  field: "totalNewToBrandSales",
  title: "New to Brand Product Sales",
  category: MetricCategory.DSP,
  color: PALETTE[10],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  requireSellingPartnerAccess: false,
  tooltip: "DSP New to Brand Product Sales",
});

export const DSP_3P_FEES: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_3P_FEES",
  field: "_3PFees",
  title: "3P Fees",
  category: MetricCategory.DSP,
  color: PALETTE[12],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  requireSellingPartnerAccess: false,
  tooltip: "DSP 3P Fees",
  higherIsBetter: false,
});

export const DSP_SUPPLY_COST: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_SUPPLY_COST",
  field: "supplyCost",
  title: "Supply Cost",
  category: MetricCategory.DSP,
  color: PALETTE[13],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  requireSellingPartnerAccess: false,
  tooltip: "DSP Supply Cost",
  higherIsBetter: false,
});

export const DSP_VIEWABLE_IMPRESSIONS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_VIEWABLE_IMPRESSIONS",
  field: "viewableImpressions",
  title: "Viewable Impressions",
  category: MetricCategory.DSP,
  color: PALETTE[14],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Viewable Impressions",
  higherIsBetter: false,
});

export const DSP_MEASURABLE_IMPRESSIONS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_MEASURABLE_IMPRESSIONS",
  field: "measurableImpressions",
  title: "Measurable Impressions",
  category: MetricCategory.DSP,
  color: PALETTE[15],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Measurable Impressions",
  higherIsBetter: false,
});

export const DSP_VIDEO_AD_START: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_VIDEO_AD_START",
  field: "videoAdStart",
  title: "Video Ad Starts",
  category: MetricCategory.DSP,
  color: PALETTE[16],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Video Ad Starts",
  higherIsBetter: false,
});

export const DSP_VIDEO_AD_FIRST_QUARTILE: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_VIDEO_AD_FIRST_QUARTILE",
  field: "videoAdFirstQuartile",
  title: "Video Ad First Quartile",
  category: MetricCategory.DSP,
  color: PALETTE[17],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Video Ad First Quartile",
  higherIsBetter: false,
});

export const DSP_VIDEO_AD_MID_POINT: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_VIDEO_AD_MID_POINT",
  field: "videoAdMidpoint",
  title: "Video Ad Mid Point",
  category: MetricCategory.DSP,
  color: PALETTE[18],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Video Ad Mid Point",
  higherIsBetter: false,
});

export const DSP_VIDEO_AD_THIRD_QUARTILE: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_VIDEO_AD_THIRD_QUARTILE",
  field: "videoAdThirdQuartile",
  title: "Video Ad Third Quartile",
  category: MetricCategory.DSP,
  color: PALETTE[19],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Video Ad Third Quartile",
  higherIsBetter: false,
});

export const DSP_VIDEO_AD_COMPLETE: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_VIDEO_AD_COMPLETE",
  field: "videoAdComplete",
  title: "Video Ad Complete",
  category: MetricCategory.DSP,
  color: PALETTE[20],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Video Ad Complete",
  higherIsBetter: false,
});

export const DSP_CPM = new RatioMetric<DspStats>({
  id: "DSP_CPM",
  numerator: DSP_COST,
  denominator: DSP_IMPRESSIONS,
  coeff: 1000,
  title: "CPM",
  category: MetricCategory.DSP,
  color: PALETTE[21],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  precision: "1.0-2",
  tooltip: "Cost per thousand impressions (Cost / Impressions × 1000)",
  higherIsBetter: false,
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_ACOS = new RatioMetric<DspStats>({
  id: "DSP_ACOS",
  numerator: DSP_COST,
  denominator: DSP_SALES,
  title: "ACOS",
  category: MetricCategory.DSP,
  color: PALETTE[3],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  isPercent: true,
  inverseColors: true,
  tooltip: "Ratio of DSP ad spend to ad sales",
  higherIsBetter: false,
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_ROAS = new RatioMetric<DspStats>({
  id: "DSP_ROAS",
  numerator: DSP_SALES,
  denominator: DSP_COST,
  title: "ROAS",
  category: MetricCategory.DSP,
  color: PALETTE[11],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  precision: "1.0-2",
  tooltip: "Ratio of revenue generated from DSP advertising to the cost of advertising",
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_DETAIL_PAGE_VIEWS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_DETAIL_PAGE_VIEWS",
  field: "totalDetailPageView",
  title: "Detail Page Views",
  category: MetricCategory.DSP,
  color: PALETTE[22],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Detail page views of the promoted and brand halo products, after an ad view or click",
});

export const DSP_BRAND_SEARCHES: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_BRAND_SEARCHES",
  field: "brandSearches",
  title: "Brand Searches",
  category: MetricCategory.DSP,
  color: PALETTE[23],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip: "Branded searches on Amazon after an ad view or click",
});

export const DSP_NEW_TO_BRAND_DETAIL_PAGE_VIEWS: Metric<DspStats> = new SummableMetric<DspStats>({
  id: "DSP_NEW_TO_BRAND_DETAIL_PAGE_VIEWS",
  field: "totalNewToBrandDPVs",
  title: "New-to-Brand Detail Page Views",
  category: MetricCategory.DSP,
  color: PALETTE[1],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: false,
  requireSellingPartnerAccess: false,
  tooltip:
    "Detail page views of the promoted and brand halo products by shoppers new to the brand over the last 12 months",
});

export const DSP_VIDEO_COMPLETION_RATE = new RatioMetric<DspStats>({
  id: "DSP_VIDEO_COMPLETION_RATE",
  numerator: DSP_VIDEO_AD_COMPLETE,
  denominator: DSP_VIDEO_AD_START,
  title: "Video Completion Rate",
  category: MetricCategory.DSP,
  color: PALETTE[2],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  isPercent: true,
  tooltip: "Share of started video ads watched to the end (Video Ad Completes / Video Ad Starts)",
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_COST_PER_COMPLETED_VIEW = new RatioMetric<DspStats>({
  id: "DSP_COST_PER_COMPLETED_VIEW",
  numerator: DSP_COST,
  denominator: DSP_VIDEO_AD_COMPLETE,
  title: "Cost per Completed View",
  category: MetricCategory.DSP,
  color: PALETTE[3],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  precision: "1.2-2",
  tooltip: "Cost / Video Ad Completes",
  higherIsBetter: false,
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_COST_PER_BRAND_SEARCH = new RatioMetric<DspStats>({
  id: "DSP_COST_PER_BRAND_SEARCH",
  numerator: DSP_COST,
  denominator: DSP_BRAND_SEARCHES,
  title: "Cost per Brand Search",
  category: MetricCategory.DSP,
  color: PALETTE[4],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  currency: true,
  precision: "1.2-2",
  tooltip: "Cost / Brand Searches",
  higherIsBetter: false,
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_BRAND_SEARCH_RATE = new RatioMetric<DspStats>({
  id: "DSP_BRAND_SEARCH_RATE",
  numerator: DSP_BRAND_SEARCHES,
  denominator: DSP_IMPRESSIONS,
  title: "Brand Search Rate",
  category: MetricCategory.DSP,
  color: PALETTE[5],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  isPercent: true,
  precision: "1.2-2",
  tooltip: "Brand Searches / Impressions",
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_VIEWABILITY = new RatioMetric<DspStats>({
  id: "DSP_VIEWABILITY",
  numerator: DSP_VIEWABLE_IMPRESSIONS,
  denominator: DSP_MEASURABLE_IMPRESSIONS,
  title: "Viewability",
  category: MetricCategory.DSP,
  color: PALETTE[6],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  isPercent: true,
  tooltip: "Viewable Impressions / Measurable Impressions. N/A when Amazon does not measure it, as on Video deals",
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DSP_NEW_TO_BRAND_SALES_SHARE = new RatioMetric<DspStats>({
  id: "DSP_NEW_TO_BRAND_SALES_SHARE",
  numerator: DSP_NEW_TO_BRAND_PRODUCT_SALES,
  denominator: DSP_SALES,
  title: "New-to-Brand Sales Share",
  category: MetricCategory.DSP,
  color: PALETTE[7],
  supportedAccountType: SupportedAccountType.VENDOR_AND_SELLER,
  isPercent: true,
  tooltip: "New to Brand Product Sales / Ad Sales",
  requireSellingPartnerAccess: false,
  mustApplyEvolutionStyle: false,
});

export const DspDisplayMetrics = [
  DSP_SALES,
  DSP_UNITS_SOLD,
  DSP_COST,
  DSP_ACOS,
  DSP_CPM,
  DSP_IMPRESSIONS,
  DSP_CLICKS,
  DSP_FEE,
  DSP_PURCHASE_CLICKS,
  DSP_PURCHASES,
  DSP_ADD_TO_CART,
  DSP_PAGE_VIEWS,
  DSP_NEW_TO_BRAND_PRODUCT_SALES,
  DSP_3P_FEES,
  DSP_SUPPLY_COST,
  DSP_ROAS,
];

export const DspVideoMetrics = [
  DSP_VIEWABLE_IMPRESSIONS,
  DSP_MEASURABLE_IMPRESSIONS,
  DSP_VIDEO_AD_START,
  DSP_VIDEO_AD_FIRST_QUARTILE,
  DSP_VIDEO_AD_MID_POINT,
  DSP_VIDEO_AD_THIRD_QUARTILE,
  DSP_VIDEO_AD_COMPLETE,
];

export const DspAwarenessMetrics = [
  DSP_IMPRESSIONS,
  DSP_COST,
  DSP_CPM,
  DSP_VIDEO_COMPLETION_RATE,
  DSP_NEW_TO_BRAND_DETAIL_PAGE_VIEWS,
  DSP_BRAND_SEARCHES,
  DSP_COST_PER_BRAND_SEARCH,
  DSP_DETAIL_PAGE_VIEWS,
  DSP_COST_PER_COMPLETED_VIEW,
  DSP_VIEWABILITY,
  DSP_BRAND_SEARCH_RATE,
  DSP_NEW_TO_BRAND_SALES_SHARE,
  DSP_SALES,
  DSP_ROAS,
  DSP_ACOS,
  DSP_VIDEO_AD_FIRST_QUARTILE,
  DSP_VIDEO_AD_MID_POINT,
  DSP_VIDEO_AD_THIRD_QUARTILE,
  DSP_CLICKS,
];
const DSP_AWARENESS_DEFAULT_METRIC_COUNT = 10;

export type DspStrategyMetrics = {
  metrics: Metric<DspStats>[];
  defaultMetrics: Metric<DspStats>[];
  chartedMetrics: Metric<DspStats>[];
  storageKeySuffix: DspMetricsType;
};

export function getDspStrategyMetrics(strategy: DspStrategyEx): DspStrategyMetrics {
  if (strategy.dspFunnel === StrategyDspFunnel.AWARENESS) {
    return {
      metrics: DspAwarenessMetrics,
      defaultMetrics: DspAwarenessMetrics.slice(0, DSP_AWARENESS_DEFAULT_METRIC_COUNT),
      chartedMetrics: [DSP_IMPRESSIONS, DSP_COST],
      storageKeySuffix: "awareness",
    };
  }
  const chartedMetrics = [DSP_SALES, DSP_COST];
  if (DspStrategyService.isDspVideoStrategy(strategy)) {
    return {
      metrics: [...DspDisplayMetrics, ...DspVideoMetrics],
      defaultMetrics: DspDisplayMetrics,
      chartedMetrics,
      storageKeySuffix: "video",
    };
  }
  return { metrics: DspDisplayMetrics, defaultMetrics: DspDisplayMetrics, chartedMetrics, storageKeySuffix: "display" };
}
